module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4MDAiIGhlaWdodD0iNDAwIiBmaWxsPSIjZmZmIj48cGF0aCBmaWxsPSIjMDAyYThmIiBkPSJNMCAwaDgwMHY0MDBIMCIvPjxwYXRoIGQ9Ik0wIDgwaDgwMHY4MEgwdjgwaDgwMHY4MEgwIi8+PHBhdGggZmlsbD0iI2NmMTQyYiIgZD0iTTM0Ni40IDIwMEwwIDB2NDAwIi8+PHBhdGggZD0iTTExNS41IDE0MGwzNS4zNSAxMDguNS05Mi41LTY3aDExNC4ybC05Mi41IDY3Ii8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/cub.svg
// module id = 2lpu
// module chunks = 0